/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/main'
    },
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
        {
          path: '/content',
          name: 'content',
          component: () => import('@/views/ContentTest.vue'),
          meta: { 
            auth: true
          }
        },
        {
          path: '/main', 
          name: 'main',
          component: () => import('@/views/Home.vue'),
          meta: { 
            auth: true,
            pageTitle: '토킹클래스',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: '메인', active: true }
            ]
          }
        },
        {
          path: '/schedule', 
          name: 'schedule',
          component: () => import('@/views/Schedule.vue'),
          props: (route) => ({ bookCode: route.query.bookCode }),
          meta: { 
            auth: true,
            pageTitle: '토킹클래스',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: '학습스케줄', active: true }
            ]
          }
        },
        {
          path: '/result', 
          name: 'result',
          component: () => import('@/views/StudyResult.vue'),
          props: (route) => ({ bookCode: route.query.bookCode }),
          meta: { 
            auth: true,
            pageTitle: '토킹클래스',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: '학습결과', active: true }
            ]
          }
        },
        {
          path: '/study', 
          name: 'study',
          component: () => import('@/views/StudyMain.vue'),
          props: (route) => ({ bookCode: route.query.bookCode, unitCode: route.query.unitCode, stepCode: route.query.stepCode }),
          meta: { 
            auth: true,
            pageTitle: '토킹클래스',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: '학습하기', active: true }
            ]
          }
        },
        {
          path: '/profile', 
          name: 'profile',
          component: () => import('@/views/user-settings/UserSettings.vue'),
          meta: { 
            auth: true,
            pageTitle: '토킹클래스',
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: '계정정보', active: true }
            ]
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
      // =============================================================================
      // PAGES
      // =============================================================================
        {
          path: '/login', 
          name: 'login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },
        {
          path: '/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ]
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  
  if (to.meta.auth && !store.getters.isLogin) {
    console.log('인증이 필요합니다.')
    next('/login')
    return
  } 
  next()
})

export default router
